import { z } from "zod";

export enum ESiteSearchField {
  /* ------------- SUBSCRIBER ------------- */
  SUBSCRIBER_ID = "subscriberId",
  SUBSCRIBER_LASTNAME = "subscriberLastname",
  SUBSCRIBER_FIRSTNAME = "subscriberFirstname",
  EMAIL = "email",
  PHONE = "phone",
  COMPANY_NAME = "companyName",
  /* ------------- SITE ------------- */
  SITE_ID = "siteId",
  EXTERN_ID = "externId",
  STREET = "street",
  POSTAL = "postal",
  TOWN = "town",
  COUNTRY = "country",
  DELIVERY_POINT = "deliveryPoint",
  /* ------------- PILOT ------------- */
  PILOT_HW_ID = "pilotHwId",
  PILOT_CS_ID = "pilotCsId",
  /* ------------- MODULATOR ------------- */
  MOD_SERIAL = "modSerial",
  MOD_HW_ID = "modHwId",
  MOD_CS_ID = "modCsId",
  MOD_NEURON_ID = "modNeuronId",
}

export enum ESiteSearchInputType {
  NUMBER = "NUMBER",
  STRING = "STRING",
}

export const ESiteSearchFieldInputType: Record<ESiteSearchField, ESiteSearchInputType> = {
  [ESiteSearchField.SUBSCRIBER_ID]: ESiteSearchInputType.NUMBER,
  [ESiteSearchField.SUBSCRIBER_LASTNAME]: ESiteSearchInputType.STRING,
  [ESiteSearchField.SUBSCRIBER_FIRSTNAME]: ESiteSearchInputType.STRING,
  [ESiteSearchField.EMAIL]: ESiteSearchInputType.STRING,
  [ESiteSearchField.PHONE]: ESiteSearchInputType.STRING,
  [ESiteSearchField.COMPANY_NAME]: ESiteSearchInputType.STRING,
  [ESiteSearchField.SITE_ID]: ESiteSearchInputType.NUMBER,
  [ESiteSearchField.EXTERN_ID]: ESiteSearchInputType.STRING,
  [ESiteSearchField.STREET]: ESiteSearchInputType.STRING,
  [ESiteSearchField.POSTAL]: ESiteSearchInputType.STRING,
  [ESiteSearchField.TOWN]: ESiteSearchInputType.STRING,
  [ESiteSearchField.COUNTRY]: ESiteSearchInputType.STRING,
  [ESiteSearchField.DELIVERY_POINT]: ESiteSearchInputType.STRING,
  [ESiteSearchField.PILOT_HW_ID]: ESiteSearchInputType.NUMBER,
  [ESiteSearchField.PILOT_CS_ID]: ESiteSearchInputType.NUMBER,
  [ESiteSearchField.MOD_SERIAL]: ESiteSearchInputType.STRING,
  [ESiteSearchField.MOD_HW_ID]: ESiteSearchInputType.NUMBER,
  [ESiteSearchField.MOD_CS_ID]: ESiteSearchInputType.NUMBER,
  [ESiteSearchField.MOD_NEURON_ID]: ESiteSearchInputType.STRING,
};

export enum ESiteSearchFilterType {
  EQUALS = "EQUALS",
  CONTAINS = "CONTAINS",
  STARTS_BY = "STARTS_BY",
  ENDS_BY = "ENDS_BY",
}

export const siteSearchFieldSchema = z.nativeEnum(ESiteSearchField);
export const siteSearchFilterTypeSchema = z.nativeEnum(ESiteSearchFilterType);
export const siteSearchInputTypeSchema = z.nativeEnum(ESiteSearchInputType);
